import React, { useEffect, useState } from 'react'
import data from '../projects.json'

export default function ProjectCard() {
    const [Projects, setProjects] = useState([])

    useEffect(() =>{
       setProjects(data)
    },[])

    const styleDiv ={
        boxShadow:"2px 2px 4px grey",
        padding:"10px",
        margin:"10px", 
    }
    return (
        <>
        {
            Projects.map(project => {
                return (
                    <div key={project.id} style={styleDiv}>
                        <h2>{project.name}</h2>
                        <h3><span style={{fontWeight:"bold"}}>Tech Used</span> : {project.tech_used}</h3>
                        <p><span style={{fontWeight:"bold"}}>Description</span> : {project.description}</p>
                        <span style={{fontWeight:"bold"}}>GitHub Repo</span><a href={project.git_repo} target="blank"> : Click Here</a>
                    </div>
                )
            })
        }
        </>
    )
}
